export const metamaskStatus = {
  DENIED_TRANSACTION: 4001,
  INSUFFICIENT_FUNDS: -32603,
  INSUFFICIENT_GAS_FUNDS: -32000,
  SOLD_OUT: 3,
  NETWORK_NOT_FOUND: 4902,
}
